<script>
import { FormWizard, TabContent } from "vue-form-wizard";

export default {
  components: { FormWizard, TabContent },
  props: {
    planoContas: {
      type: Array,
      required: true
    },
    oldContaPagar: {
      type: Object,
      required: true
    },
    professionals: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      contas: [],
      filteredTipos: [],
      pagamentos: [],
      errors: {},
      loader: { get: false },
      titleBody: "Editar Conta a Pagar",
      selectedGrupoPgto: null,
      currentContaPagar: {
        vencimento: null,
        numero_documento: null,
        valor_pagar: null,
        descricao: null,
        conta_credito_id: null,
        conta_debito_id: null,
        tipo_id: null,
        conta_credito: null,
        conta_debito: null,
        tipo: null,
        professional_id: null,
      },
    };
  },
  created() {
    this.contas            = this.planoContas.filter(conta => conta.conta_pgto === 1)
    this.pagamentos        = this.planoContas.filter(conta => conta.conta_pgto === 0 && conta.grupo_pgto !== null)
    this.currentUser       = JSON.parse(localStorage.getItem('user'))
    this.currentEmpresa    = JSON.parse(localStorage.getItem('currentEmpresa'))
    this.currentContaPagar = this.oldContaPagar
  },
  mounted() {
    this.$emit("newTitle", "Alterar Conta a Pagar")
    this.currentContaPagar.valor_pagar = this.formatterFloatBR(this.oldContaPagar.valor_pagar, 2)

    // Preencher o input contaContabil com descrição conta_credito
    this.$refs.conta_credito_id.value = this.oldContaPagar.conta_crebito.descricao
    this.filterContaContabil(this.$refs.conta_credito_id.value)
    this.currentContaPagar.conta_credito = this.oldContaPagar.conta_crebito
    this.currentContaPagar.conta_credito_id = this.oldContaPagar.conta_crebito.id

    // Preencher o input contaPagamento com descrição conta_debito
    this.$refs.conta_debito_id.value = this.oldContaPagar.conta_debito.descricao
    this.filterContaPagamento(this.$refs.conta_debito_id.value)
  },
  methods: {
    back() {
      this.$emit('back');
    },
    setNewTitle() {
      this.titleBody = 'Editar Conta a Pagar'
    },
    formatCurrency(value) {
      // Converter valor numérico para formato brasileiro (ex: 1234.56 -> "1.234,56")
      if (!value) return ''
      return parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDateForInput(dateString) {
      // Converter data para formato YYYY-MM-DD para input type="date"
      if (!dateString) return null
      
      try {
        // Se a data já está no formato correto (YYYY-MM-DD)
        if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return dateString
        }
        
        // Se a data está no formato brasileiro (DD/MM/YYYY)
        if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
          const [day, month, year] = dateString.split('/')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
        
        // Tentar converter usando Date
        const date = new Date(dateString)
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear()
          const month = (date.getMonth() + 1).toString().padStart(2, '0')
          const day = date.getDate().toString().padStart(2, '0')
          return `${year}-${month}-${day}`
        }
        
        return null
      } catch (error) {
        console.error('Erro ao formatar data:', error)
        return null
      }
    },
    filterContaContabil(descricao) {
      let contasDespesas = this.planoContas.filter(conta => conta.conta_pgto === 1)

      if (!descricao) {
        this.contas = contasDespesas
      } else {
        this.contas = contasDespesas.filter(conta => conta.descricao.toLowerCase().includes(descricao.toLowerCase()))
      }
    },
    filterContaPagamento(descricao) {
      let contasPagamentos = this.planoContas.filter(conta => conta.conta_pgto === 0 && conta.grupo_pgto !== null)

      if (!descricao) {
        this.pagamentos = contasPagamentos
      } else {
        this.pagamentos = contasPagamentos.filter(conta => conta.descricao.toLowerCase().includes(descricao.toLowerCase()))
      }
    },
    setConta(conta_credito) {
      if (conta_credito === this.currentContaPagar.conta_credito) {
        this.currentContaPagar.conta_credito_id = null
        this.currentContaPagar.conta_credito = null
        return
      }

      this.currentContaPagar.conta_credito_id = conta_credito.id
      this.currentContaPagar.conta_credito = conta_credito
      this.$refs.wizardContasPagar.nextTab()
    },
    setPagamento(conta_debito) {
      if (conta_debito === this.currentContaPagar.conta_debito) {
        this.currentContaPagar.conta_debito_id = null
        this.currentContaPagar.conta_debito = null
        return
      }

      this.currentContaPagar.conta_debito_id = conta_debito.id
      this.currentContaPagar.conta_debito = conta_debito
      this.$refs.wizardContasPagar.nextTab()
    },
    doPut() {
      // Validar se todos os campos obrigatórios estão preenchidos
      if (!this.currentContaPagar.valor_pagar) {
        console.error('Valor não pode ser vazio')
        return
      }

      let valorFormatado = this.currentContaPagar.valor_pagar

      if (typeof valorFormatado === 'string') {
        valorFormatado = valorFormatado.replace(/\./g, '').replace(',', '.').trim()
      }

      let data = {
        id: this.oldContaPagar.id, // Incluir ID para edição
        conta_debito_id: this.currentContaPagar.conta_debito_id,
        conta_credito_id: this.currentContaPagar.conta_credito_id,
        descricao: this.currentContaPagar.descricao,
        numero_documento: this.currentContaPagar.numero_documento,
        valor_pagar: valorFormatado,
        vencimento: this.currentContaPagar.vencimento,
        data_emissao: this.oldContaPagar.data_emissao,
        ano_competencia: parseInt(this.currentContaPagar.competencia.split('-')[0]),
        mes_competencia: parseInt(this.currentContaPagar.competencia.split('-')[1]),
        tipo_id: this.oldContaPagar.tipo_id,
        status: this.oldContaPagar.status || 0,
        quantidade_parcelas: this.oldContaPagar.quantidade_parcelas || 1,
        professional_id: this.currentContaPagar.professional_id || null,
      }

      console.log(data)
      this.$emit('doPut', data)
    },
    // Validação global antes de mudar de aba
    beforeTabChange(oldIndex) {
      return this.validateCurrentStep(oldIndex)
    },
    // Validação específica do step 1
    validateStep1() {
      this.errors = {}

      if (!this.currentContaPagar.vencimento) {
        this.errors.vencimento = 'Data de emissão é obrigatória'
        this.$refs.vencimento.focus()
      }

      if (!this.currentContaPagar.numero_documento) {
        this.errors.numero_documento = 'Documento é obrigatório'
        this.$refs.numero_documento.focus()
      }

      if (!this.currentContaPagar.valor_pagar) {
        this.errors.valor_pagar = 'Valor é obrigatório'
        this.$refs.valor_pagar.focus()
      }

      return Object.keys(this.errors).length === 0
    },
    validateStep2() {
      this.errors = {}

      if (!this.currentContaPagar.conta_credito_id) {
        this.errors.conta_credito_id = 'Conta Contábil é obrigatória'
        this.$refs.conta_credito_id.focus()
      }

      return Object.keys(this.errors).length === 0
    },
    validateStep3() {
      this.errors = {}

      if (!this.currentContaPagar.conta_debito_id) {
        this.errors.conta_debito_id = 'Conta Pagamento é obrigatória'
        this.$refs.conta_debito_id.focus()
      }

      return Object.keys(this.errors).length === 0
    },
    validateCurrentStep(stepIndex) {
      switch (stepIndex) {
        case 0:
          return this.validateStep1()
        case 1:
          return this.validateStep2()
        case 2:
          return this.validateStep3()
      }
    }
  },
};
</script>
<template>
    <form-wizard color="#556ee6"
      ref="wizardContasPagar"
      next-button-text="Avançar"
      finish-button-text="Atualizar"
      back-button-text="Voltar"
      @on-complete="doPut"
      :before-change="beforeTabChange"
    >
      <tab-content icon="mdi mdi-file-percent"
        :before-change="validateStep1"
      >
        <div class="row">
          <div class="col-md-2">
            <label for="vencimento">Vencimento</label>
            <input type="date" class="form-control" id="vencimento" v-model="currentContaPagar.vencimento" ref="vencimento">
            <span v-if="errors.vencimento" class="error">{{ errors.vencimento }}</span>
          </div>
          <div class="col-md-2">
            <label for="competencia">Competência</label>
            <!-- input com mês/ano -->
            <b-form-input type="month" class="form-control" id="competencia" v-model="currentContaPagar.competencia" ref="competencia">
              <template #prepend>
                <b-form-input-group>
                  <b-form-input-group-prepend is-text>
                    <b-icon icon="calendar" />
                  </b-form-input-group-prepend>
                </b-form-input-group>
              </template>
            </b-form-input>
            <span v-if="errors.competencia" class="error">{{ errors.competencia }}</span>
          </div>
          <div class="col-md-4">
            <label for="numero_documento">Documento</label>
            <input type="text" class="form-control" id="numero_documento" v-model="currentContaPagar.numero_documento" ref="numero_documento">
            <span v-if="errors.numero_documento" class="error">{{ errors.numero_documento }}</span>
          </div>
          <div class="col-md-2">
            <label for="valor_pagar">Valor R$</label>
            <input type="text" class="form-control text-right" id="valor_pagar" ref="valor_pagar"
              v-model="currentContaPagar.valor_pagar"
              @input="formatInputFloat($event,currentContaPagar,'valor_pagar')"
            >
            <span v-if="errors.valor_pagar" class="error">{{ errors.valor_pagar }}</span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <label for="descricao">Histórico (descrição)</label>
            <input type="text" class="form-control" id="descricao" v-model="currentContaPagar.descricao">
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6">
            <label for="professional_id">Profissional <small class="text-muted">(opcional)</small></label>
            <select id="professional_id" class="form-control" v-model="currentContaPagar.professional_id">
              <option :value="null">Sem profissional</option>
              <option v-for="professional in professionals" :key="professional.id" :value="professional.id">
                {{ professional.name }}
              </option>
            </select>
          </div>
        </div>
      </tab-content>
      <tab-content icon="mdi mdi-file-tree"
        :before-change="validateStep2"
      >
        <h2>Selecionar Categoria</h2>
        <b-row cols="1">
          <div class="position-relative">
            <form class="app-search d-none d-lg-block" @submit.prevent>
              <div class="position-relative">
                <input
                  name="contaContabil"
                  type="text"
                  class="form-control"
                  placeholder="Buscar por Conta Contábil"
                  @input="filterContaContabil($event.target.value)"
                  ref="conta_credito_id"
                />
                <span class="ri-search-line"></span>
              </div>
            </form>
          </div>
          <span v-if="errors.conta_credito_id" class="error">{{ errors.conta_credito_id }}</span>
        </b-row>
        <div class="row">
          <div class="col-12 max-h-96 overflow-y-auto">
            <!-- loop array contas -->
            <b-row cols="1" v-for="conta in contas" :key="conta.id" class="cursor-pointer">
              <b-col @click="setConta(conta)">
                <b-card class="flex" :class="(currentContaPagar.conta_credito_id === conta.id) ? 'bg-light' : 'bg-default'">
                  <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                    <span class="text-lg font-semibold">{{ conta.descricao.substring(0, 1) }}</span>
                  </b-badge>
                  <span class="flex items-center ml-3">
                    {{  conta.descricao }}
                  </span>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </tab-content>
      <tab-content icon="mdi mdi-bank-transfer"
        :before-change="validateStep3"
      >
        <h2>Selecionar Pagamento</h2>
        <b-row cols="1">
          <div class="position-relative">
            <form class="app-search d-none d-lg-block" @submit.prevent>
              <div class="position-relative">
                <input
                  name="contaContabil"
                  type="text"
                  class="form-control"
                  placeholder="Buscar por Conta Pagamento"
                  @input="filterContaPagamento($event.target.value)"
                  ref="conta_debito_id"
                />
                <span class="ri-search-line"></span>
              </div>
            </form>
          </div>
          <span v-if="errors.conta_debito_id" class="error">{{ errors.conta_debito_id }}</span>
        </b-row>
        <div class="row">
          <div class="col-12 max-h-96 overflow-y-auto">
            <b-row cols="1" v-for="pagamento in pagamentos" :key="pagamento.id" class="cursor-pointer">
              <b-col @click="setPagamento(pagamento)">
                <b-card class="flex" :class="(currentContaPagar.conta_debito_id === pagamento.id) ? 'bg-light' : 'bg-default'">
                  <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                    <span class="text-lg font-semibold">{{ pagamento.descricao.substring(0, 1) }}</span>
                  </b-badge>
                  <span class="flex items-center ml-3">
                    {{  pagamento.descricao }}
                  </span>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </tab-content>
    </form-wizard>
</template>

<style>
.w-12 {
  width: 3rem;
}
.h-12 {
  height: 3rem;
}
.text-lg {
  font-size: 1.900rem;
  line-height: 1.75rem;
}
.rounded-full {
  border-radius: 9999px;
}
.justify-center {
  justify-content: center;
}
.font-semibold {
  font-weight: 600;
}
.items-center {
  align-items: center;
}
.pt-8 {
  padding-top: 0.5rem;
}
.max-h-96 {
  max-height: 24rem;
}
.overflow-y-auto {
  overflow-y: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.capitalize {
  text-transform: capitalize;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

/* CSS para destacar abas com erro */
.vue-form-wizard .wizard-nav-pills > li.has-error > a {
  color: #dc3545 !important;
  border-color: #dc3545 !important;
}

.vue-form-wizard .wizard-nav-pills > li.has-error > a:after {
  background-color: #dc3545 !important;
}
</style>
